<template>
  <div class="aboutSection">
    <!-- About-App-Section-Start -->
    <section class="row_am about_app_section">
      <!-- container start -->
      <div class="container">
        <!-- row start -->
        <div class="row">
          <div class="col-lg-6">
            <!-- about images -->
            <div class="about_img" data-aos="fade-in" data-aos-duration="1500">
              <div class="frame_img">
                <img
                  class="moving_position_animatin"
                  src="images/about-frame02.png"
                  alt="image"
                />
              </div>
              <div class="screen_img">
                <img
                  class="moving_animation"
                  src="images/about-screen02.png"
                  alt="image"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <!-- about text -->
            <div class="about_text">
              <div
                class="section_title"
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-delay="100"
              >
                <!-- h2 -->
                <!-- <h2>Some awesome words <span>about app.</span></h2> -->
                <h2>What People Love <span>About Salt</span></h2>

                <!-- p -->
                <p>
                  Salt brings convenience, trust, and professionalism to the braiding community—one appointment at a time.</p>
<p>“Booking braids has never been this easy. I can see prices, chat, and book instantly.”</p>
<p>“Salt helped me grow my client base and manage my schedule better.”</p>
               
              </div>

              <!-- UL -->
              <ul
                class="app_statstic"
                id="counter"
                data-aos="fade-in"
                data-aos-duration="1500"
              >
                <li>
                  <div class="icon">
                    <img src="images/download02.png" alt="image" />
                  </div>
                  <div class="text">
                    <p>
                      <span class="counter-value" data-count="17">0</span
                      ><span>M+</span>
                    </p>
                    <p>Download</p>
                  </div>
                </li>
                <li>
                  <div class="icon">
                    <img src="images/followers02.png" alt="image" />
                  </div>
                  <div class="text">
                    <p>
                      <span class="counter-value" data-count="08">0 </span
                      ><span>M+</span>
                    </p>
                    <p>Followers</p>
                  </div>
                </li>
                <li>
                  <div class="icon">
                    <img src="images/reviews02.png" alt="image" />
                  </div>
                  <div class="text">
                    <p>
                      <span class="counter-value" data-count="2300">1500</span
                      ><span>+</span>
                    </p>
                    <p>Reviews</p>
                  </div>
                </li>
                <li>
                  <div class="icon">
                    <img src="images/countries02.png" alt="image" />
                  </div>
                  <div class="text">
                    <p>
                      <span class="counter-value" data-count="8.5">0</span
                      ><span>K+</span>
                    </p>
                    <p>Bookings</p>
                  </div>
                </li>
              </ul>
              <!-- UL end -->
              


              <router-link to="/contact-us" class="btn puprple_btn"
                data-aos="fade-in"
                data-aos-duration="1500">START FREE TRIAL</router-link>
            </div>
          </div>
        </div>
        <!-- row end -->
      </div>
      <!-- container end -->
    </section>
    <!-- About-App-Section-end -->
  </div>
</template>

<script>
export default {
  name: "AboutSection",

  methods: {
    // goToAboutPage() {
    //   this.$router.push({ name: "ContactUs" }); // Navigate to the 'About' page
    // },
  },
};
</script>

<style>
.aboutSection {
  width: 100%;
  /* height: 100vh; */
  background: url(../../public/images/bgn01.jpg) repeat;
}
.about_text p {
  color: #420000;
}
</style>
